module.exports = __webpack_public_path__ + "static/media/wsp.b9418140.png";